import { render, staticRenderFns } from "./addPosts.vue?vue&type=template&id=f7326722"
import script from "./addPosts.vue?vue&type=script&lang=js"
export * from "./addPosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports